export default __webpack_public_path__ + "2f876125493d1d7c935aa3aa86ca488d.jpg";